module.exports = __webpack_public_path__ + "static/media/warning.42c07d9f.svg";